module.exports = __webpack_public_path__ + "img/checklist.322ff4ac.png";